import 'css-chunksrc/client/scenes/taskRemoval/taskDetails/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_1cpol_1",
  "allocation": "_allocation_1cpol_1",
  "summary": "_summary_1cpol_17"
};